module.exports = "/_next/static/images/img9-be495ae9f5b792f2f54e7d9e33f06fc7.jpg";